<template>
  <div class="vx-col lg:w-1/2 w-full">
    <vx-card title="Update Try & Buy">
      <div class="mt-5">
        <form>
          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Customer NID<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" type="text" disabled="" v-validate="'required|greaterThanZero|min:10|max:17'" placeholder="Nid no should be 10, 13 or 17 character" data-vv-as="NID No" @keypress="onlyNidNumber"
                            v-model="customer_nid"
                            name="customer_nid"/>
                  <span class="text-danger text-sm" v-show="errors.has('customer_nid')">{{ errors.first('customer_nid') }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/1 w-full ">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full ">
                  <span>Customer Mobile No<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    disabled=""
                    type="tel"
                    v-validate="'required|min:11|max:11'"
                    data-vv-validate-on="blur"
                    name="mobile"
                    placeholder="Use 11 digit mobile number"
                    v-model="customer_mobile"
                    data-vv-as="Customer Mobile No"
                    @keypress="onlyNumber"
                    class="w-full"/>
                  <span class="text-danger text-sm"  v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-4">
                  <span>Customer Name<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input disabled="" class="w-full" v-validate="'required'" data-vv-as="Customer Name" name="customer_name"   type="text" v-model="customer_name"/>
                  <span class="text-danger text-sm"  v-show="errors.has('customer_name')">{{ errors.first('customer_name') }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-4">
                  <span>Customer Address<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input disabled=""  class="w-full" v-validate="'required'" data-vv-as="Customer Address" name="customer_address"  type="text" v-model="customer_address"/>
                  <span class="text-danger text-sm"  v-show="errors.has('customer_address')">{{ errors.first('customer_address') }}</span>
                </div>
              </div>
            </div>

          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Product Article<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input disabled="" class="w-full" v-validate="'required'" data-vv-as="Product Article" name="product_article"  type="text" v-model="product_article"/>
                  <span class="text-danger text-sm"  v-show="errors.has('product_article')">{{ errors.first('product_article') }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-2">
                  <span>Product SL No<sup>*</sup></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input disabled="" class="w-full" v-validate="'required'" data-vv-as="Product SL No" name="product_sl" type="text" v-model="product_sl"/>
                  <span class="text-danger text-sm"  v-show="errors.has('product_sl')">{{ errors.first('product_sl') }}</span>
                </div>
              </div>
            </div>

          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full mt-4">
                  <span>Status </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <v-select v-model="status" :disabled="!agreed" class="w-full select-large"
                            :options="statusValue" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/1 w-full " v-if="status === 'Sold'">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full ">
                  <span>Invoice No</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input  class="w-full" v-validate="'required'" type="text" data-vv-as="Invoice No" name="invoice_no" v-model="invoice_no"/>
                  <span class="text-danger text-sm"  v-show="errors.has('invoice_no')">{{ errors.first('invoice_no') }}</span>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/1 w-full" v-if="status === 'Return'">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full ">
                  <span>Remarks</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <!--<vs-textarea v-model="remarks"/>-->
                  <v-select v-model="remarks" class="w-full select-large" data-vv-as="Remarks" name="remarks"
                            :options="remarksList" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm"  v-show="errors.has('remarks')">{{ errors.first('remarks') }}</span>
                  <br>
                  <vs-textarea v-if="remarks==='Others'" placeholder="Other Remarks" v-validate="'required'" data-vv-as="Others Remark" name="otherRemarks" v-model="otherRemarks"/>
                  <span class="text-danger text-sm"  v-show="errors.has('otherRemarks')">{{ errors.first('otherRemarks') }}</span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
                     color="success" class="mb-2 float-right" @click="updateTrail" :disabled="!validateForm || !agreed">Update
          </vs-button>

        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
  import updateTrail from '../graphql/WashingMachineTrailUpdate.gql'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import vSelect from 'vue-select'
  import Datepicker from 'vuejs-datepicker'
  import { Validator } from 'vee-validate';
  import gql from 'graphql-tag'
  import moment from 'moment'
  const dict = {
  }
  Validator.localize('en', dict.en)
  export default {
    data(){
      return{
        product_article :'',
        product_sl :'',
        customer_nid :'',
        customer_name :'',
        customer_mobile :'',
        customer_address :'',
        agreed : false,
        status :'',
        remarks :'',
        invoice_no:'',
        otherRemarks:'',
        statusValue:['Sold','Return'],
        remarksList:['Washing Quality not satisfactory','Product manufacturing fault','High Electricity Cost','Others']
      }
    },
    apollo: {
      trail: {
        query: gql`
         query trail($id: ID){
          trail(id:$id){
            id
            product_article
            product_sl
            customer_nid
            customer_name
            customer_mobile
            customer_address
            agreed
            status
            remarks
            invoice_no
          }
         }
         `,
        variables () {
          return {
            id: this.$route.params.id
          }
        },
        update: (data) => data.trail
      }

    },
    created() {
      this.$validator.extend(
        'greaterThanZero',{
          getMessage: field =>  field + ' must be 10, 13 or 17 digit.',
          validate: (value) => {

            // value must be > zero
            if (value <= 0 ) {
              this.customer_nid = null;
            }
            if (value.toString().length === 10){
              return true;
            }
            else if(value.toString().length === 13){
              return true
            }else if(value.toString().length === 17){
              return true
            }else {
              return false;
            }
          }
        });
    },
    computed: {
      validateForm () {
        return !this.errors.any() && this.product_article !== ''
          && this.product_sl !== '' && this.customer_nid !== ''
          && this.customer_name !== '' && this.customer_mobile !== ''
          && this.customer_address !== ''
          && (this.status ==='Sold'?this.invoice_no!=='': this.invoice_no='')
          || (this.status ==='Return'?this.remarks!=='': this.remarks ='')
          &&(this.remarks!==''?this.remarks!=='Others': this.remarks !== '')
          || (this.remarks==='Others'?this.otherRemarks !=='':this.otherRemarks ='')
          /*|| (this.remarks ==='Others'& this.otherRemarks !=='')*/

      }
    },
    watch: {
      trail (value) {
        if(value !== null){
          this.trail = value;
          let remarksList = ['Washing Quality not satisfactory','Product manufacturing fault','High Electricity Cost','Others']
          this.product_article = value.product_article;
          this.product_sl = value.product_sl;
          this.customer_nid = value.customer_nid;
          this.customer_name = value.customer_name;
          this.customer_mobile = value.customer_mobile;
          this.customer_address = value.customer_address;
          this.status = value.status;
          this.agreed = value.agreed;
          this.remarks = value.remarks;
          this.invoice_no = value.invoice_no;

          let findRemark = remarksList.find(item => item === value.remarks);
          console.log("====>",value.remarks)
          if(value.remarks === null || value.remarks === ''){
            this.remarks = null
          }else if(findRemark === undefined){
            this.remarks = 'Others'
            this.otherRemarks = value.remarks;
          }
        }
      },
      status(value){
        console.log(value)
        if(value === 'Sold'){
          this.invoice_no =''
        }
        if(value === 'Return'){
          this.remarks =''
          this.otherRemarks =''
        }
      },
      remarks(value){
        if(value === 'Others'){
          this.otherRemarks =''
        }
      }
    },
    methods :{
      async updateTrail () {
        if(this.remarks === 'Others'){
          this.remarks = this.otherRemarks;
        }
        await this.$apollo.mutate({
          mutation: updateTrail,
          variables: {
            id: this.$route.params.id,
            product_article: this.product_article,
            product_sl: this.product_sl,
            customer_nid: this.customer_nid,
            customer_name: this.customer_name,
            customer_mobile: this.customer_mobile,
            customer_address: this.customer_address,
            status: this.status|| "",
            remarks: this.remarks|| "",
            invoice_no: this.invoice_no|| ""
          }
        }).then((data) => {
          this.$router.push('/washing_machine_trial').catch(() => {});
          this.$vs.notify({
            title: 'Update',
            text: 'Successfully Updated.',
            color: "success",
            position: 'top-right'
          })

        }).catch((error) => {
          this.$vs.notify({
            title: 'Error!',
            text: 'Something went wrong.',
            color: "danger",
            position: 'top-right'
          })
        })
      },
      onlyNumber($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
      onlyNidNumber ($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
    },
    components: {
      FormWizard,
      TabContent,
      'v-select': vSelect,
      Datepicker
    }
  }
</script>
<style>
  sup{
    color:red
  }
</style>
